export const ORDER_CANCELLATION_REASON = [
  {
    label: 'Out of delivery trade area',
    value: 'Out of delivery trade area',
    checked: false,
  },
  {
    label: 'Restaurant Close',
    value: 'Restaurant Close',
    checked: false,
  },
  {
    label: 'Item is unavailable',
    value: 'Item is unavailable',
    checked: false,
  },
  {
    label: 'Delivery Timing issue',
    value: 'Delivery Timing issue',
    checked: false,
  },
  {
    label: 'Busy cooks',
    value: 'Busy cooks',
    checked: false,
  },
  {
    label: 'Carrier hasn\'t arrived yet',
    value: 'Carrier hasn\'t arrived yet',
    checked: false,
  },
  {
    label: 'Others',
    value: 'Others',
    checked: false,
  },
];

export const REPORT_ISSUE_REASONS = [
  {
    label: 'The behaviour of the foodman was unprofessional',
    value: 'UNPROFESSIONAL',
  },
  {
    label: 'Payment was not made properly',
    value: 'PAYMENT',
  },
  {
    label: 'Foodman arrived restaurant in late',
    value: 'LATE_ARRIVED',
  },
  {
    label: 'Foodman’s outfit was dirty',
    value: 'DIRTY_OUTFIT',
  },
  {
    label: 'Foodman was different from app info',
    value: 'FOODMAN_DIFFERENT',
  },
  {
    label: 'Item Change issue',
    value: 'FOODITEM_CHANGE',
  },

  {
    label: 'Can not update item price',
    value: 'FOOD_ITEM_UPDATE_PRICE',
  },
  {
    label: 'Can not update item',
    value: 'FOOD_ITEM_UPDATE',
  },
  {
    label: 'Food man did not come',
    value: 'FOODMAN_MISSING',
  },

  {
    label: 'Can not update restaurant time',
    value: 'RESTO_ISSUE',
  },
  {
    label: 'Can not cancel the order',
    value: 'CANCEL_ORDER_ISSUE',
  },

  {
    label: 'Cancel order',
    value: 'CANCEL_ORDER',
  },
  {
    label: 'Call Request',
    value: 'REQUEST_CALL',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
];

export const MENUS_MAKE_UNAVAILABLE_DURATION_OPTIONS = [
  {
    value: 15,
    label: 'For 15 min',
    isCustomized: false,
  }, {
    value: 30,
    label: 'For 30 min',
    isCustomized: false,
  },
  {
    value: 60,
    label: '',
    isCustomized: true,
  },
  {
    value: 1440,
    label: 'For 1 day',
    isCustomized: false,
  },
  {
    value: 0,
    label: 'Until I turn on',
    isCustomized: false,
  },
];
export const RIGHT_SIDEBAR_WIDTH = 624;

export const BUSINESS_HOUR_MENU_OPTIONS = {
  WORKING_HOURS: 'WorkingHours',
  SPECIAL_HOLIDAYS: 'SpecialHolidays',
};

export const APPROVAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const MENU_APPROVAL_FILTERS = [
  {
    id: 1,
    label: 'Food Items',
    value: 'item',
  },
  {
    id: 2,
    label: 'Category',
    value: 'category',
  },
];

export const WEEK_DAYS = [
  { id: 1, name: 'Sunday' },
  { id: 2, name: 'Monday' },
  { id: 3, name: 'Tuesday' },
  { id: 4, name: 'Wednesday' },
  { id: 5, name: 'Thursday' },
  { id: 6, name: 'Friday' },
  { id: 7, name: 'Saturday' },
];
export const RESPONSE_MODAL_DATA = {
  FOOD_3000: {
    title: 'Error Occured',
    body: 'It seems you have added overlapping hours for the same day. To proceed, please recheck and add the correct hours.',
  },
  FOOD_3002: {
    title: 'Error',
    body: 'Your holiday schedule(s) are overlapping with your pending request(s). Please delete your previous request before submitting a new one.',
  },
  FOOD_3003: {
    title: 'Error',
    body: 'Your holiday request(s) conflict with already approved holiday schedule(s) below:',
  },
  FOOD_3004: {
    title: 'Error',
    body: 'Your holiday schedule(s) are overlapping. Please check again.',
  },
  FOOD_3005: {
    title: 'Error',
    body: 'One or more holiday(s) start before next day according to restaurant\'s time',
  },
};
